export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2018.a0716e34.pdf";